import * as z from "zod";

/** Distinct product-family tags in the supplies catalog, for rule targeting. */
export const getSuppliesProductFamilyTags = {
  name: "getSuppliesProductFamilyTags" as const,
  input: z.object({ search: z.string().nullish() }),
  output: z.object({ tags: z.array(z.string()) }),
};
